import { Expose, Type } from "class-transformer";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { TaskTypeDto } from "@/core/features/task-types/task-type.dto";

export class PlusHasTaskTypeDto extends BaseEntityDto {
  @Expose()
  plusId: string;

  @Expose()
  taskTypeId: string;

  @Expose()
  @Type(() => TaskTypeDto)
  taskType?: TaskTypeDto;
}
